import React from 'react'
import { SimpleSelect, SimpleSelectProps } from '../SimpleSelect/SimpleSelect'
import { Flag } from '../../misc'
import styled from 'styled-components'
import { CountryCode } from 'libphonenumber-js'
import { useTranslation } from 'react-i18next'

const OptionStyled = styled.div`
  display: flex;
  align-items: center;
`

const FlagStyled = styled(Flag)`
  margin-right: 5px;
`

type CountryItem = {
  id: CountryCode
  title: string
}

type CountrySelectOption = {
  id: CountryCode
  title: string
}

export type CountrySelectProps = {
  value?: CountryCode
  list?: CountryItem[]
  onChange: (code: CountryCode) => void
  title?: string
} & Omit<SimpleSelectProps<CountrySelectOption>, 'options' | 'onChange'>

export const CountrySelect: React.FC<CountrySelectProps> = ({ list = [], value, ...rest }) => {
  const { t } = useTranslation('ui')

  return (
    <SimpleSelect
      options={list}
      formatOptionLabel={data => (
        <OptionStyled>
          <FlagStyled code={data.id} />
          {data.title}
        </OptionStyled>
      )}
      value={value}
      placeholder={t('CountrySelect.placeholder')}
      {...rest}
    />
  )
}
